/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API
 * ### Poizon API Documentation  **Официальная документация Poizon API.**  #### 📚 Ресурсы  - [Официальный GitHub SDK](https://github.com/Poizon-API/public-api)  - [OpenApi JSON](https://poparce.ru/api/dewu/api-json)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { BrowserAccountDto } from '../models';
// @ts-ignore
import type { CreateClientPayload } from '../models';
/**
 * ClientApi - axios parameter creator
 * @export
 */
export const ClientApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Создать аккаунт dewu
         * @param {CreateClientPayload} createClientPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerCreateClient: async (createClientPayload: CreateClientPayload, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createClientPayload' is not null or undefined
            assertParamExists('clientControllerCreateClient', 'createClientPayload', createClientPayload)
            const localVarPath = `/client/createClient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createClientPayload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Удалить аккаунт dewu
         * @param {number} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerDeleteClient: async (clientId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('clientControllerDeleteClient', 'clientId', clientId)
            const localVarPath = `/client/deleteClient`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            if (clientId !== undefined) {
                localVarQueryParameter['client-id'] = clientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение своих аккаунтов dewu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerGetClients: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/client/getClients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение информации о своих аккаунтах dewu
         * @param {number} [status] Статус клиента (необязательно)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerGetClientsCount: async (status?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/client/getClientsCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Получение информации об аккаунтах dewu по userId
         * @param {string} userId 
         * @param {number} [status] Статус клиента (необязательно)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerGetClientsCountByUserId: async (userId: string, status?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('clientControllerGetClientsCountByUserId', 'userId', userId)
            const localVarPath = `/client/getClientsCountByUserId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication x-api-key required
            await setApiKeyToObject(localVarHeaderParameter, "x-api-key", configuration)

            // authentication accessToken required

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientApi - functional programming interface
 * @export
 */
export const ClientApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Создать аккаунт dewu
         * @param {CreateClientPayload} createClientPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientControllerCreateClient(createClientPayload: CreateClientPayload, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BrowserAccountDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientControllerCreateClient(createClientPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.clientControllerCreateClient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Удалить аккаунт dewu
         * @param {number} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientControllerDeleteClient(clientId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientControllerDeleteClient(clientId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.clientControllerDeleteClient']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение своих аккаунтов dewu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientControllerGetClients(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BrowserAccountDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientControllerGetClients(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.clientControllerGetClients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение информации о своих аккаунтах dewu
         * @param {number} [status] Статус клиента (необязательно)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientControllerGetClientsCount(status?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientControllerGetClientsCount(status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.clientControllerGetClientsCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Получение информации об аккаунтах dewu по userId
         * @param {string} userId 
         * @param {number} [status] Статус клиента (необязательно)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientControllerGetClientsCountByUserId(userId: string, status?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientControllerGetClientsCountByUserId(userId, status, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ClientApi.clientControllerGetClientsCountByUserId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ClientApi - factory interface
 * @export
 */
export const ClientApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientApiFp(configuration)
    return {
        /**
         * 
         * @summary Создать аккаунт dewu
         * @param {CreateClientPayload} createClientPayload 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerCreateClient(createClientPayload: CreateClientPayload, options?: RawAxiosRequestConfig): AxiosPromise<BrowserAccountDto> {
            return localVarFp.clientControllerCreateClient(createClientPayload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Удалить аккаунт dewu
         * @param {number} clientId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerDeleteClient(clientId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.clientControllerDeleteClient(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение своих аккаунтов dewu
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerGetClients(options?: RawAxiosRequestConfig): AxiosPromise<Array<BrowserAccountDto>> {
            return localVarFp.clientControllerGetClients(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение информации о своих аккаунтах dewu
         * @param {number} [status] Статус клиента (необязательно)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerGetClientsCount(status?: number, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.clientControllerGetClientsCount(status, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Получение информации об аккаунтах dewu по userId
         * @param {string} userId 
         * @param {number} [status] Статус клиента (необязательно)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientControllerGetClientsCountByUserId(userId: string, status?: number, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.clientControllerGetClientsCountByUserId(userId, status, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientApi - object-oriented interface
 * @export
 * @class ClientApi
 * @extends {BaseAPI}
 */
export class ClientApi extends BaseAPI {
    /**
     * 
     * @summary Создать аккаунт dewu
     * @param {CreateClientPayload} createClientPayload 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientControllerCreateClient(createClientPayload: CreateClientPayload, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).clientControllerCreateClient(createClientPayload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Удалить аккаунт dewu
     * @param {number} clientId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientControllerDeleteClient(clientId: number, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).clientControllerDeleteClient(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение своих аккаунтов dewu
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientControllerGetClients(options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).clientControllerGetClients(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение информации о своих аккаунтах dewu
     * @param {number} [status] Статус клиента (необязательно)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientControllerGetClientsCount(status?: number, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).clientControllerGetClientsCount(status, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Получение информации об аккаунтах dewu по userId
     * @param {string} userId 
     * @param {number} [status] Статус клиента (необязательно)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public clientControllerGetClientsCountByUserId(userId: string, status?: number, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).clientControllerGetClientsCountByUserId(userId, status, options).then((request) => request(this.axios, this.basePath));
    }
}

